/**
 * Suffisso del sotto-campo che contiene il candidato scelto all'interno della
 * lista selezionata nel widget di scelta lista elettorale. È il contratto
 * condiviso fra il widget (theme-mic, che costruisce il nome del campo) ed
 * extractVotes (common-web, che lo riconosce per estrarre i voti CS): tenerlo in
 * un unico punto evita che una modifica da un lato rompa i voti dall'altro.
 */
export const electoralListChooserCandidateSuffix = '@candidateId';

/**
 * Suffisso del sotto-oggetto che contiene i campi (colonne) del candidato scelto
 * — nome, cognome, … — salvati nel form così che le espressioni possano
 * referenziarli, come fa il widget CTS con `@columns`. Anche extractVotes lo usa
 * per escludere questi sotto-campi dall'estrazione del voto.
 */
export const electoralListChooserColumnsSuffix = '@columns';

/**
 * Suffisso del sotto-campo che contiene il nome della lista selezionata, salvato
 * nel form così che le espressioni possano referenziarlo (#57760). Anche
 * extractVotes lo usa per escludere il sotto-campo dall'estrazione del voto.
 */
export const electoralListChooserListNameSuffix = '@listName';
